'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _assessedSupplier = require('./src/assessed-supplier');

var _assessedSupplier2 = _interopRequireDefault(_assessedSupplier);

var _avCheck = require('./src/av-check');

var _avCheck2 = _interopRequireDefault(_avCheck);

var _companyVideo = require('./src/company-video');

var _companyVideo2 = _interopRequireDefault(_companyVideo);

var _diamond = require('./src/diamond');

var _diamond2 = _interopRequireDefault(_diamond);

var _newDiamond = require('./src/new-diamond');

var _newDiamond2 = _interopRequireDefault(_newDiamond);

var _greyNewDiamond = require('./src/grey-new-diamond');

var _greyNewDiamond2 = _interopRequireDefault(_greyNewDiamond);

var _eCredit = require('./src/e-credit');

var _eCredit2 = _interopRequireDefault(_eCredit);

var _goldSupplier = require('./src/gold-supplier');

var _goldSupplier2 = _interopRequireDefault(_goldSupplier);

var _halfDiamond = require('./src/half-diamond');

var _halfDiamond2 = _interopRequireDefault(_halfDiamond);

var _hundredPercent = require('./src/hundred-percent');

var _hundredPercent2 = _interopRequireDefault(_hundredPercent);

var _identityChecked = require('./src/identity-checked');

var _identityChecked2 = _interopRequireDefault(_identityChecked);

var _identityDisabled = require('./src/identity-disabled');

var _identityDisabled2 = _interopRequireDefault(_identityDisabled);

var _identityUnchecked = require('./src/identity-unchecked');

var _identityUnchecked2 = _interopRequireDefault(_identityUnchecked);

var _logisticService = require('./src/logistic-service');

var _logisticService2 = _interopRequireDefault(_logisticService);

var _onsiteCheck = require('./src/onsite-check');

var _onsiteCheck2 = _interopRequireDefault(_onsiteCheck);

var _securePayment = require('./src/secure-payment');

var _securePayment2 = _interopRequireDefault(_securePayment);

var _tradeAssurance = require('./src/trade-assurance');

var _tradeAssurance2 = _interopRequireDefault(_tradeAssurance);

var _plusSupplier = require('./src/plus-supplier');

var _plusSupplier2 = _interopRequireDefault(_plusSupplier);

var _plusSupplierW = require('./src/plus-supplier-w');

var _plusSupplierW2 = _interopRequireDefault(_plusSupplierW);

var _alibabaLogo = require('./src/alibaba-logo');

var _alibabaLogo2 = _interopRequireDefault(_alibabaLogo);

var _verified = require('./src/verified');

var _verified2 = _interopRequireDefault(_verified);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ICON_MAP = {
  'assessed-supplier': _assessedSupplier2['default'],
  'av-checked': _avCheck2['default'],
  'company-video': _companyVideo2['default'],
  diamond: _diamond2['default'],
  'new-diamond': _newDiamond2['default'],
  'grey-new-diamond': _greyNewDiamond2['default'],
  'e-credit': _eCredit2['default'],
  'gold-supplier': _goldSupplier2['default'],
  'plus-supplier': _plusSupplier2['default'],
  'plus-supplier-w': _plusSupplierW2['default'],
  'half-diamond': _halfDiamond2['default'],
  'hundred-percent': _hundredPercent2['default'],
  'identity-checked': _identityChecked2['default'],
  'identity-disabled': _identityDisabled2['default'],
  'identity-unchecked': _identityUnchecked2['default'],
  'logistic-service': _logisticService2['default'],
  'onsite-check': _onsiteCheck2['default'],
  'secure-payment': _securePayment2['default'],
  'trade-assurance': _tradeAssurance2['default'],
  'alibaba-logo': _alibabaLogo2['default'],
  'verified-icon': _verified2['default']
};
var SIZE_MAP = {
  xxs: 8,
  xs: 12,
  small: 16,
  medium: 20,
  large: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64
};

function IcbuIcon(props) {
  var type = props.type,
      size = props.size,
      className = props.className,
      others = _objectWithoutProperties(props, ['type', 'size', 'className']);

  var cls = (0, _classnames2['default'])(_defineProperty({
    'icbu-icon-svg': true
  }, className, className));
  var Tag = ICON_MAP[type];
  if (!Tag) {
    return null;
  }

  var numSize = Number(size) || SIZE_MAP[size] || SIZE_MAP.medium;
  return _react2['default'].createElement(Tag, _extends({}, others, { className: cls, size: numSize }));
}

IcbuIcon.defaultProps = {
  size: 64
};

exports['default'] = IcbuIcon;
module.exports = exports['default'];